import * as React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  styled,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

interface DialogModalProps {
  title: string
  open: boolean
  children?: React.ReactNode
  handleClose?: () => void
  className?: string
}

const DialogModal = ({
  children,
  title,
  open,
  handleClose,
  className = '',
}: DialogModalProps) => {
  return (
    <BootstrapDialog
      className={`dialog-modal-container ${className}`}
      aria-labelledby='customized-dialog-title'
      open={open}
      scroll='paper'
      transitionDuration={500}
    >
      <DialogTitle id='customized-dialog-title'>
        <Typography variant='h2' className='text-left'>
          {title}
        </Typography>
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
    </BootstrapDialog>
  )
}

export default DialogModal
